export default [
  {
    path: '/administrador/revistas',
    name: 'list_magazine_administration',
    component: () => import('./pages/crudMagazine/List.vue'),
    meta: {
      layout: 'admin',
      requiresAuth: true,
      pageTitle: 'Revistas',
      breadcrumb: [
        {
          text: 'revistas',
          active: true,
        },
      ],
    },
  },
]
